export const englishDomTheme = {
    primary: "#166341",
    accent: "#9D3C21",
    background: "#FFFFFF",
    card: "#FFFFFF",
    text: "#18231D",
    mutedText: "#5C6260",
    buttonText: "#FFFFFF",
    progress: "#166341",
    border: "#D9DDDA",
    radius: "8px",
    fontFamily: "Manrope, ui-sans-serif, system-ui, sans-serif",
    headlineScale: 1,
    bodyScale: 1,
    spacingDensity: "comfortable",
    answerWeight: 500
};
